"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exec = void 0;
var ScrollMagic = require("ScrollMagic");
var common_1 = require("./common");
function exec() {
    var mql = window.matchMedia('(min-width:768px)');
    /*
     * Hero
     */
    var onMediaQueryChangeHero = function (e) {
        document.querySelectorAll('#hero p > span').forEach(function (element) {
            element.style.setProperty('--height', element.querySelector('span').offsetHeight + 'px');
        });
    };
    mql.addEventListener('change', onMediaQueryChangeHero);
    document.fonts.ready.then(function (fontFaceSet) {
        onMediaQueryChangeHero(mql);
        document.querySelector('#hero').classList.add('font-loaded');
    });
    /*
     * Form
     */
    var form = document.querySelector('#application form');
    var fields = form.querySelectorAll('input, textarea');
    var sendButton = form.querySelector('.send button');
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        fields.forEach(function (field) {
            field.disabled = true;
        });
        sendButton.disabled = true;
        sendButton.classList.add('sending', 'disabled');
        fetch(form.action, { method: form.method, body: fd })
            .then(function (response) { return response.json(); })
            .then(function (result) {
            fields.forEach(function (field) {
                field.disabled = false;
            });
            sendButton.disabled = false;
            sendButton.classList.remove('sending', 'disabled');
            form.querySelectorAll('.error:not(:empty)').forEach(function (element) {
                element.innerHTML = '';
            });
            if (result.sent) {
                form.style.display = 'none';
                var thanks = document.querySelector('#application .thanks');
                thanks.style.display = 'block';
                (0, common_1.scrollToElement)(thanks);
            }
            else {
                var firstErrorField = null;
                var _loop_1 = function (name_1, error) {
                    var field = form.querySelector("[name=\"".concat(name_1, "\"]"));
                    field.addEventListener('input', function (e) {
                        field.parentElement.querySelector('.error').innerHTML = '';
                        sendButton.disabled = form.querySelectorAll('.error:not(:empty)').length > 0;
                        sendButton.classList.toggle('disabled', sendButton.disabled);
                    }, { once: true, passive: true });
                    field.parentElement.querySelector('.error').innerHTML = error;
                    if (!firstErrorField || firstErrorField.scrollHeight > field.scrollHeight) {
                        firstErrorField = field;
                    }
                };
                for (var _i = 0, _a = Object.entries(result.errors); _i < _a.length; _i++) {
                    var _b = _a[_i], name_1 = _b[0], error = _b[1];
                    _loop_1(name_1, error);
                }
                if (firstErrorField) {
                    (0, common_1.scrollToElement)(firstErrorField);
                }
                sendButton.disabled = form.querySelectorAll('.error:not(:empty)').length > 0;
                sendButton.classList.toggle('disabled', sendButton.disabled);
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    });
    /*
     * ScrollMagic
     */
    var controller = new ScrollMagic.Controller();
    document.querySelectorAll('#hero, #about, #howto, #application, #support, #support .support-option, #support .application').forEach(function (element) {
        new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: .7,
            reverse: false
        })
            .setClassToggle(element, 'enter')
            .addTo(controller);
    });
    document.querySelectorAll('#support > i').forEach(function (cloud) {
        new ScrollMagic.Scene({
            triggerElement: cloud,
            triggerHook: 'onEnter',
            duration: function () { return window.innerHeight + cloud.clientHeight; }
        })
            .on("progress", function (event) {
            cloud.style.setProperty('--scroll-rate', "".concat(event.progress));
        })
            .addTo(controller);
    });
}
exports.exec = exec;
;
